module.exports = __webpack_public_path__ + "img/download.fae33f61.svg";